import { render } from "./HeaderMenuTop.vue?vue&type=template&id=3b980ccc&scoped=true"
import script from "./HeaderMenuTop.vue?vue&type=script&lang=js"
export * from "./HeaderMenuTop.vue?vue&type=script&lang=js"

import "./HeaderMenuTop.vue?vue&type=style&index=0&id=3b980ccc&scoped=true&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b980ccc"]])

export default __exports__